<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane label="基本信息" name="first">
        <div class="ivu-tabs-tabpane" style="visibility: visible;">
          <div data-v-75eea3a4="" class="ivu-pb">
            <div data-v-75eea3a4="" class="row">
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所名称</p>
                <div data-v-75eea3a4="">{{form_data.name}}</div>
              </div>
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所类型</p>
                <div data-v-75eea3a4="">{{form_data.type_name}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane> -->
      <el-tab-pane label="培训形式" name="first">
        <div style="margin-bottom: 8px;">
          <l-auth-button type="primary" class="ivu-mr" auth="specification_add_btn" @click="showAdd('type')"> 添加 </l-auth-button>
          <!-- <l-auth-button type="primary" auth="specs_import_btn" @click="import_visible=true" :loading="import_loading"> 导入 </l-auth-button> -->
        </div>
        <l-table :data="form_data" v-loading="loading" row-key="id" style=" max-height: 30vh;">
        
          <!-- <el-table-column prop="danger_lavel" label="隐患等级" width="100">
            <template slot-scope="{ row }">
              <el-tag type="danger" size="small" v-if="row.danger_lavel == 1" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <el-tag type="warning" size="small" v-if="row.danger_lavel == 2" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <el-tag type="success" size="small" v-if="row.danger_lavel == 3" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <el-tag type="success" size="small" v-if="row.danger_lavel == 4" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <a size="small" v-else disable-transitions></a>
            </template>
          </el-table-column> -->
            <el-table-column prop="index" label="序号" width="100"> </el-table-column>
            <el-table-column prop="is_active" label="状态" width="100">
              <template slot-scope="{ row }">
                <el-tag :type="row.is_active == 1 ? 'success' : 'danger'" size="small" disable-transitions>{{ row.specification_state }}</el-tag>
                <!-- <el-tag type="success" size="small"  disable-transitions>{{ STATE_NAMES[row.state] }}</el-tag> -->
              </template>
            </el-table-column>
            <el-table-column  prop="material_type_name" label="所属类别" min-width="200"> </el-table-column>
            <!-- <el-table-column  prop="code" label="规格编码" min-width="200"> </el-table-column> -->
            <el-table-column  prop="specification_name" label="培训形式" min-width="200"> </el-table-column>
            <el-table-column prop="abbreviation" label="缩写" min-width="200"> </el-table-column>
          
          
          <el-table-column fixed="right" label="操作"  min-width="120" align="center">
            <template slot-scope="{ row }">
              <l-auth-text-button type="primary" auth="specification_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>修改</l-auth-text-button>
              <span class="l-action-separator">|</span>
              <l-auth-text-button type="danger" auth="specification_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
            </template>
          </el-table-column>
        </l-table>
      </el-tab-pane>
      
      <el-tab-pane label="培训题库" name="second">
        <div style="margin-bottom: 8px;">
          <l-auth-button type="primary" class="ivu-mr" auth="itembank_add_btn" @click="showAdd('itembank')"> 添加 </l-auth-button>
        </div>
        <l-table :data="itembank_data" v-loading="loading" row-key="id" style=" max-height: 30vh;">
            <el-table-column prop="index" label="序号" width="100"> </el-table-column>
            <el-table-column prop="is_active" label="状态" width="100">
              <template slot-scope="{ row }">
                <el-tag :type="row.is_active == 1 ? 'success' : 'danger'" size="small" disable-transitions>{{ row.inspect_interval_state }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column  prop="material_type_name" label="所属类别" min-width="200"> </el-table-column>
            <el-table-column  prop="question" label="题目" min-width="200"> </el-table-column>
            <el-table-column  prop="question_type" label="题目类型" min-width="200"> </el-table-column>
            <el-table-column  prop="answer_YN" label="答案_YN" min-width="200"> </el-table-column>
            <el-table-column  prop="answer_ABCD" label="答案_ABCD" min-width="200"> </el-table-column>
            <el-table-column  prop="reply_Y" label="回答_Y" min-width="200"> </el-table-column>
            <el-table-column  prop="reply_N" label="回答_N" min-width="200"> </el-table-column>
            <el-table-column  prop="reply_A" label="回答_A" min-width="200"> </el-table-column>
            <el-table-column  prop="reply_B" label="回答_B" min-width="200"> </el-table-column>
            <el-table-column  prop="reply_C" label="回答_C" min-width="200"> </el-table-column>
            <el-table-column  prop="reply_D" label="回答_D" min-width="200"> </el-table-column>
          <el-table-column fixed="right" label="操作"  min-width="120" align="center">
            <template slot-scope="{ row }">
              <l-auth-text-button type="primary" auth="itembank_edit_btn" @click="showItemBankEdit(row.id)"><i class="el-icon-edit"></i>修改</l-auth-text-button>
              <span class="l-action-separator">|</span>
              <l-auth-text-button type="danger" auth="itembank_del_btn" @click="delItemBank(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
            </template>
          </el-table-column>
        </l-table>
      </el-tab-pane>
      
      <!-- <el-tab-pane label="检查周期" name="second">
        <div style="margin-bottom: 8px;">
          <l-auth-button type="primary" class="ivu-mr" auth="specification_add_btn" @click="showAdd()"> 添加 </l-auth-button>
        </div>
        <l-table :data="itembank_data" v-loading="loading" row-key="id" style=" max-height: 30vh;">
            <el-table-column prop="index" label="序号" width="100"> </el-table-column>
            <el-table-column prop="is_active" label="状态" width="100">
              <template slot-scope="{ row }">
                <el-tag :type="row.is_active == 1 ? 'success' : 'danger'" size="small" disable-transitions>{{ row.inspect_interval_state }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column  prop="material_type_name" label="所属类别" min-width="200"> </el-table-column>
            <el-table-column  prop="inspect_interval_number" label="检查周期" min-width="200"> </el-table-column>
            <el-table-column  prop="inspect_interval_unit" label="检查周期单位" min-width="200"> </el-table-column>
          <el-table-column fixed="right" label="操作"  min-width="120" align="center">
            <template slot-scope="{ row }">
              <l-auth-text-button type="primary" auth="specification_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>修改</l-auth-text-button>
              <span class="l-action-separator">|</span>
              <l-auth-text-button type="danger" auth="specification_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
            </template>
          </el-table-column>
        </l-table>
      </el-tab-pane> -->
    </el-tabs>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>

    <!--修改-->
    <l-dialog :visible.sync="edit_visible" title="修改" width="800px">
      <l-rental-info-edit @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id"></l-rental-info-edit>
    </l-dialog>
    <!--添加培训形式-->
    <l-dialog :visible.sync="save_visible" title="添加" width="800px">
      <l-rental-info-edit @on-success="onAddSucess" :visible.sync="save_visible" :type_id="type_id"></l-rental-info-edit>
    </l-dialog>
    <!--修改试题库-->
    <l-dialog :visible.sync="itembank_edit_visible" title="修改" width="800px">
      <l-itembank-edit @on-success="onItemBankEditSucess" :visible.sync="itembank_edit_visible" :id="itembank_edit_id"></l-itembank-edit>
    </l-dialog>
    <!--添加试题库-->
    <l-dialog :visible.sync="itembank_save_visible" title="添加" width="800px">
      <l-itembank-edit @on-success="onItemBankAddSucess" :visible.sync="itembank_save_visible" :type_id="type_id"></l-itembank-edit>
    </l-dialog>

    <!--导入-->
    <l-dialog :visible.sync="import_visible" title="导入" width="800px">
      <l-info-import @on-success="onImportSuccess" :visible.sync="import_visible" />
    </l-dialog>
  </div>

</template>

<script>
import { LEVEL } from '../public/basis.js';
import InfoImport from "./InfoImport.vue";
import InfoSave from "./InfoSave.vue";
import ItembankEdit from "./ItembankEdit.vue";
export default {
  name: 'l-specification-info',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
    [InfoSave.name]: InfoSave,
    [InfoImport.name]: InfoImport,
    [ItembankEdit.name]: ItembankEdit,
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      activeName: 'first',
      loading: false,//页面是否加载中
      //表单数据
      edit_id: 0,
      itembank_edit_id: 0,
      edit_visible: false,
      save_visible: false,
      itembank_edit_visible: false,
      itembank_save_visible: false,
      form_data: [],
      itembank_data: [],
      type_id: 0,
      LEVEL:LEVEL,
      import_visible:false
    }
  },
  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleClick() {
    },
    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },
    //显示试题库修改界面
    showItemBankEdit(id) {
      this.itembank_edit_id = id;
      this.$nextTick(() => {
        this.itembank_edit_visible = true;
      });
    },

    //显示添加界面
    showAdd(mode) {
        console.log('Info.show'+mode);
      this.$nextTick(() => {
        if (mode=='type') {
            this.save_visible = true;
        } else if (mode=='itembank') {
            this.itembank_save_visible = true;
        }
        
      });
    },

    //添加成功回调
    onAddSucess() {
      this.save_visible = false;
      this.getData();
    },
    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getData();
    },
    //添加成功回调
    onItemBankAddSucess() {
      this.itembank_save_visible = false;
      this.getData();
    },
    //编辑成功回调
    onItemBankEditSucess() {
      this.itembank_edit_visible = false;
      this.getData();
    },
    //获取数据
    getData() {
      if (this.hasId) {
        this.type_id = this.$props.id;
        this.loading = true;
        this.$_invoke(`materialType_specificationGetList`, { type_id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.itembank_data = ret.data_itembank;
        }).finally(() => {
          this.loading = false;
        });

      }
    },
    // inspectInfo() {
    //   // // console.log(row);
    // },
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`materialType_specificationDel`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getData();
          });
        })
        .catch(() => { });
    },
    //删除试题
    delItemBank(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`materialType_itemBankDel`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getData();
          });
        })
        .catch(() => { });
    },
    //显示导入
    onImportSuccess() {
      this.import_visible = false;
      this.getData();
    },

  },
}
</script>